"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constant = require("../Theme/constant");

var _default = {
  PropTypes: {
    theme: _propTypes.default.string,
    accessible: _propTypes.default.bool,
    customProperties: _propTypes.default.object,
    translation: _propTypes.default.object,
    isMobile: _propTypes.default.bool,
    currency: _propTypes.default.string.isRequired,
    priceSlashSuffix: _propTypes.default.string.isRequired,
    meal: _propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      isComplimentary: _propTypes.default.bool,
      isSelected: _propTypes.default.bool,
      imageUrl: _propTypes.default.string.isRequired,
      name: _propTypes.default.string.isRequired,
      price: _propTypes.default.number.isRequired,
      discount: _propTypes.default.number.isRequired,
      slashedPrice: _propTypes.default.number.isRequired,
      labels: _propTypes.default.arrayOf(_propTypes.default.string.isRequired),
      isVeg: _propTypes.default.bool,
      complimentaryDrinks: _propTypes.default.arrayOf(_propTypes.default.shape({
        id: _propTypes.default.string.isRequired,
        isSelected: _propTypes.default.bool,
        name: _propTypes.default.string.isRequired,
        price: _propTypes.default.number.isRequired
      })),
      addonDesserts: _propTypes.default.arrayOf(_propTypes.default.shape({
        id: _propTypes.default.string.isRequired,
        isSelected: _propTypes.default.bool,
        imageUrl: _propTypes.default.string.isRequired,
        name: _propTypes.default.string.isRequired,
        price: _propTypes.default.number.isRequired
      }))
    }),
    handleOnSelect: _propTypes.default.func,
    isDisabled: _propTypes.default.bool,
    preventSelectionDisplay: _propTypes.default.bool,
    isBundleSelected: _propTypes.default.bool,
    includedIcon: _propTypes.default.string,
    isAtleastMealSelected: _propTypes.default.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    customProperties: {},
    translation: {},
    isMobile: false,
    meal: null,
    handleOnSelect: function handleOnSelect() {},
    isDisabled: false,
    preventSelectionDisplay: false,
    isBundleSelected: false,
    includedIcon: '',
    isAtleastMealSelected: false
  }
};
exports.default = _default;